<template>
    <div class="page-wrapper has-bg">
        <PageHeader/>

        <main class="main-hero">
            <div class="container hero-container position-relative">
                <div class="row hero-row">
                    <div class="col-lg-7 hero-text">
                        <div>
                            <div class="slick-slider js-hero-carousel">
                                <div>
                                    <h1 class="fadeInRight">{{ trans('home.heading', 'Dancer\'s Got Talent') }}</h1>
                                    <h3 class="font-weight-light fadeInUp">
                                        {{ trans('home.first_info', 'Every Christmas eight reindeer are leading Santa\'s sleigh - Dasher, Prancer, Vixen, Comet, Cupid, Donner, Blitzen and ...') }}
                                    </h3>
                                </div>
                                <div>
                                    <h1>{{ trans('home.heading', 'Dancer\'s Got Talent') }}</h1>
                                    <h3 class="font-weight-light">
                                        {{ trans('home.second_info', 'Dancer is our guy - the party animal, the unstoppable energizer, who leads the pack rocking to the beat through the nighty sky...') }}
                                    </h3>
                                    <h3>
                                        <strong>{{ trans('home.third_info', 'Help to get the hooves grooving with some trendy moves, and rekindle the Christmas cheer!') }}</strong>
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <nav class="hero-nav">
                            <div class="hero-nav-inner">
                                <div class="dots-wrapper d-flex d-md-none"></div>

                                <div class="arrows">
                                    <a href="javascript:;" class="arrow-prev js-prev-arrow">
                                        <img src="../assets/svg/icons/arrow.svg" alt="Icon">
                                    </a>

                                    <a href="javascript:;" class="arrow-next js-next-arrow">
                                        <img src="../assets/svg/icons/arrow.svg" alt="Icon">
                                    </a>
                                </div>

                                <div class="d-flex ml-0 ml-md-auto">
                                    <a class="btn btn-primary mx-auto my-3 mr-md-0 my-md-0" href="#" @click="next()">
                                        {{ trans('home.next', 'Next') }}
                                    </a>
                                </div>
                            </div>

                            <p class="d-none d-md-block"></p>
                        </nav>
                    </div>
                    <div class="col-lg-5">
                        <div class="hero-image">
                            <img src="../assets/reindeer-1.png" alt="Image"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hero-pattern">
                <div class="pattern-inner">
                    <div class="pattern-block flex-fill" v-for="n in [1, 2, 3, 4, 5, 6]">
                        <span class="pattern-item" v-for="i in [1, 2, 3, 4, 5]"></span>
                    </div>
                </div>
            </div>
        </main>

        <iframe src="assets/sounds/silence.mp3" allow="autoplay" id="audio" style="display:none"></iframe>

        <audio id="player" autoplay loop>
            <source src="assets/sounds/intro.mp3" type="audio/mp3">
        </audio>

        <CookieAlert />
    </div>
</template>

<script>
    import PageHeader from '@/components/PageHeader.vue'
    import CookieAlert from '@/components/CookieAlert.vue'

    export default {
        name: 'Home',
        components: {
            PageHeader,
            CookieAlert
        },

        data() {
            return {
                key: '_' + Math.random().toString(36).substr(2, 9),
            }
        },

        mounted() {
            let $carousel = $('.js-hero-carousel')

            $carousel.on('init', function () {
                let $activeSlide = $carousel.find('.slick-active')
                $activeSlide.find('.fadeInRight, .fadeInUp').addClass('animated')
            })

            $carousel.slick({
                autoplay: true,
                autoplaySpeed: 10000,
                fade: true,
                dots: false,
                arrows: true,
                prevArrow: $('.js-prev-arrow'),
                nextArrow: $('.js-next-arrow'),

                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            appendDots: $('.dots-wrapper'),
                        }
                    }
                ]
            })

            /*$carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                let $targetSlide = $carousel.find('[data-slick-index="'+nextSlide+'"]')

                $targetSlide.find('.animated').removeClass('animated')
                $targetSlide.find('.fadeInRight, .fadeInUp').addClass('animated')
            })*/

            let keyTimeout = null
            document.onkeydown = function (e) {
                // Arrow left or A
                if (e.keyCode == 37 || e.keyCode == 65) {
                    $('.is-pressed').removeClass('is-pressed')
                    $('.js-prev-arrow').addClass('is-pressed')

                    $carousel.slick('slickPrev')
                }

                // Arrow right or D
                if (e.keyCode == 39 || e.keyCode == 68) {
                    $('.is-pressed').removeClass('is-pressed')
                    $('.js-next-arrow').addClass('is-pressed')

                    $carousel.slick('slickNext')
                }

                if (keyTimeout !== null) {
                    clearTimeout(keyTimeout)
                }

                keyTimeout = setTimeout(() => {
                    $('.is-pressed').removeClass('is-pressed')
                }, 300);
            }

            var audio = document.getElementById('player')
                audio.volume = 0.2
        },

        methods: {
            next() {
                dataLayer.push({
                    event: 'GAevent',
                    eventCategory: 'LP - Xmasdancer',
                    eventAction: 'Game start',
                    eventLabel: 'Start game ; Lang:' + localStorage.getItem('locale'),
                    nonInteraction: false
                });

                this.$nextTick(() => {
                    this.$router.push({
                        name: 'game',
                        key: '_' + Math.random().toString(36).substr(2, 9)
                    });
                });
            }
        }
    }
</script>
